// extracted by mini-css-extract-plugin
export default {"accept-btn":"styles_accept-btn__puOzP","reject-btn":"styles_reject-btn__c8zXt","head-pop":"styles_head-pop__eyR1J"};